import axios from "axios";
import { call, put, takeLatest } from "redux-saga/effects";
import {
  GET_COMPANY_DATA_FAILURE,
  GET_COMPANY_DATA_SUCCESS,
  GET_HOSTS_FAILURE,
  GET_HOSTS_SUCCESS,
  GET_VISITOR_TAGS_FAILURE,
  GET_VISITOR_TAGS_SUCCESS,
  GET_VISITOR_MODULE_SETTINGS_FAILURE,
  GET_VISITOR_MODULE_SETTINGS_SUCCESS,
  GET_EXTERNAL_DATA_FAILURE,
  GET_EXTERNAL_DATA_SUCCESS,
} from "../actions/index";
import authSaga from "./authSaga";

const URL = "https://api.screencom.ch";

export function* FetchCompanyData(action) {
  try {
    const accessToken = yield call(authSaga, { type: "FETCH_PERMISSIONS_USER_REQUEST" });
    if (accessToken) {
      const accessToken = yield call(authSaga, { type: "GET_COMPANY_DATA_REQUEST" });
      const res = yield axios.post(URL + "/api/load_company_data", action.payload, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });
      yield put(GET_COMPANY_DATA_SUCCESS(res.data));
    } else {
      throw new Error("Failed to fetch access token for company data.");
    }
  } catch (err) {
    yield put(GET_COMPANY_DATA_FAILURE(err));
  }
}

export function* FetchHost(action) {
  try {
    const accessToken = yield call(authSaga, { type: "GET_HOSTS_REQUEST" });
    if (accessToken) {
      const accessToken = yield call(authSaga, { type: "GET_HOSTS_REQUEST" });
      const res = yield axios.post(URL + "/teams/hosts", action.payload.payload, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });
      yield put(GET_HOSTS_SUCCESS(res.data.host));
    } else {
      throw new Error("Failed to fetch access token for host.");
    }
  } catch (err) {
    yield put(GET_HOSTS_FAILURE(err));
  }
}

/** Sprach-Tags des Kunden (Typ `language`) — Auswahl beim Besucher. */
export function* FetchVisitorLanguages(action) {
  try {
    const accessToken = yield call(authSaga, { type: "GET_VISITOR_LANGUAGES_REQUEST" });
    if (!accessToken) {
      throw new Error("Failed to fetch access token for visitor languages.");
    }
    const res = yield axios.post(
      URL + "/visitor-tag/list",
      { customer_id: action.payload?.customer_id, tag_type: "language" },
      { headers: { Authorization: `Bearer ${accessToken}` } },
    );
    yield put({ type: "GET_VISITOR_LANGUAGES_SUCCESS", payload: res.data?.tags || [] });
  } catch (err) {
    yield put({ type: "GET_VISITOR_LANGUAGES_FAILURE", payload: err });
  }
}

export function* FetchVisitorTags(action) {
  try {
    const accessToken = yield call(authSaga, { type: "GET_VISITOR_TAGS_REQUEST" });
    if (accessToken) {
      const res = yield axios.post(URL + "/visitor-tag/list", action.payload, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });
      yield put(GET_VISITOR_TAGS_SUCCESS(res.data?.tags || []));
    } else {
      throw new Error("Failed to fetch access token for visitor tags.");
    }
  } catch (err) {
    yield put(GET_VISITOR_TAGS_FAILURE(err));
  }
}

/**
 * Visitor-Modul-Settings aller Standorte laden.
 *
 * Ohne `location_id` liefert der Endpoint die Einstellungen des Visitor-Moduls
 * für jeden Standort des Kunden (bei nur einem Standort ein einzelnes Objekt).
 * Abgelegt wird eine Map `location_id → settings`.
 */
export function* FetchVisitorModuleSettings(action) {
  try {
    const accessToken = yield call(authSaga, { type: "GET_VISITOR_MODULE_SETTINGS_REQUEST" });
    if (!accessToken) {
      throw new Error("Failed to fetch access token for visitor module settings.");
    }
    const res = yield axios.post(
      URL + "/module/list",
      { customer_id: action.payload?.customer_id, module_name: "Visitor" },
      { headers: { Authorization: `Bearer ${accessToken}` } },
    );
    const entries = Array.isArray(res.data?.data) ? res.data.data : [res.data?.data];
    const byLocation = {};
    entries.forEach((entry) => {
      if (entry && entry.location_id != null) {
        byLocation[String(entry.location_id)] = entry.settings || {};
      }
    });
    yield put(GET_VISITOR_MODULE_SETTINGS_SUCCESS(byLocation));
  } catch (err) {
    yield put(GET_VISITOR_MODULE_SETTINGS_FAILURE(err));
  }
}

/**
 * Externe Daten eines Standorts — für die Türberechtigungen die Dormakaba-
 * Raumzonen, Türgruppen und Türen (`key: "visitor_door"`).
 */
export function* FetchExternalData(action) {
  try {
    const accessToken = yield call(authSaga, { type: "GET_EXTERNAL_DATA_REQUEST" });
    if (!accessToken) {
      throw new Error("Failed to fetch access token for external data.");
    }
    const res = yield axios.post(
      URL + "/api/external_data",
      {
        key: action.payload?.key,
        source: action.payload?.source,
        location_id: action.payload?.location_id,
      },
      { headers: { Authorization: `Bearer ${accessToken}` } },
    );
    if (res.data?.status === false) {
      yield put(GET_EXTERNAL_DATA_FAILURE(res.data));
      return;
    }
    yield put(GET_EXTERNAL_DATA_SUCCESS(res.data));
  } catch (err) {
    yield put(GET_EXTERNAL_DATA_FAILURE(err));
  }
}

export default function* companySaga() {
  yield takeLatest("GET_COMPANY_DATA_REQUEST", FetchCompanyData);
  yield takeLatest("GET_HOSTS_REQUEST", FetchHost);
  yield takeLatest("GET_VISITOR_TAGS_REQUEST", FetchVisitorTags);
  yield takeLatest("GET_VISITOR_LANGUAGES_REQUEST", FetchVisitorLanguages);
  yield takeLatest("GET_VISITOR_MODULE_SETTINGS_REQUEST", FetchVisitorModuleSettings);
  yield takeLatest("GET_EXTERNAL_DATA_REQUEST", FetchExternalData);
}
